import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Resultados reales" className="border-y border-white/5 bg-ink-2" data-id="element-149" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" data-id="element-150" data-mp="2wvdu3sckxw27">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-151" data-mp="2ix5rb3sv40j4">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-152" data-mp="2nvz4ev48lpir">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-153" data-mp="2985spli9v75g">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-154" data-mp="2dyuj0xi7ty30">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}